import { denormalize } from 'normalizr';
import { createSelector } from 'reselect';
import { activity as activitySchema } from '../lib/schema.js';
import { CALL_API, HTTP_METHODS } from '../middlewares/api.js';
import { selectEntities } from './entities.js';

// API Actions

const CREATE_ACTIVITY_REQUEST = 'changesync/activities/CREATE_ACTIVITY_REQUEST';
const CREATE_ACTIVITY_SUCCESS = 'changesync/activities/CREATE_ACTIVITY_SUCCESS';
const CREATE_ACTIVITY_FAILURE = 'changesync/activities/CREATE_ACTIVITY_FAILURE';
const UPDATE_ACTIVITY_REQUEST = 'changesync/activities/UPDATE_ACTIVITY_REQUEST';
const UPDATE_ACTIVITY_SUCCESS = 'changesync/activities/UPDATE_ACTIVITY_SUCCESS';
const UPDATE_ACTIVITY_FAILURE = 'changesync/activities/UPDATE_ACTIVITY_FAILURE';
const DELETE_ACTIVITY_REQUEST = 'changesync/activities/DELETE_ACTIVITY_REQUEST';
const DELETE_ACTIVITY_SUCCESS = 'changesync/activities/DELETE_ACTIVITY_SUCCESS';
const DELETE_ACTIVITY_FAILURE = 'changesync/activities/DELETE_ACTIVITY_FAILURE';

// Initial State

const initialState = {
  /**
   * @property {object} activityIds
   * Arrays of activity IDs indexed by project ID
   * @example
   * {
   *   [projectId]: [activityId, activityId, ...]
   * }
   */
  activityIds: {},
};

// Action Creators

export const createActivity = (projectId, activity) => ({
  [CALL_API]: {
    types: [
      CREATE_ACTIVITY_REQUEST,
      CREATE_ACTIVITY_SUCCESS,
      CREATE_ACTIVITY_FAILURE,
    ],
    endpoint: `projects/${projectId}/activities`,
    method: HTTP_METHODS.POST,
    schema: activitySchema,
    body: { activity },
  },
});

export const updateActivity = (id, activity) => ({
  [CALL_API]: {
    types: [
      UPDATE_ACTIVITY_REQUEST,
      UPDATE_ACTIVITY_SUCCESS,
      UPDATE_ACTIVITY_FAILURE,
    ],
    endpoint: `activities/${id}`,
    method: HTTP_METHODS.PUT,
    schema: activitySchema,
    body: { activity },
  },
});

export const deleteActivity = (id) => ({
  [CALL_API]: {
    types: [
      DELETE_ACTIVITY_REQUEST,
      DELETE_ACTIVITY_SUCCESS,
      DELETE_ACTIVITY_FAILURE,
    ],
    endpoint: `activities/${id}`,
    method: HTTP_METHODS.DELETE,
  },
});

// Selectors

const selectActivityId = (_, props) => props.activityId;

export const selectActivity = createSelector(
  selectActivityId,
  selectEntities,
  (activityId, entities) => denormalize(activityId, activitySchema, entities)
);
